import { FC } from "react";
import { TableOldNewWrapper } from "./styles";
import { ArrowToRightIcon } from "shared/ui/icons";
import { COLORS } from "shared/consts";

type DiaryOldNewValueProps = {
  oldValue?: string | number;
  newValue: string | number;
}

export const DiaryOldNewValue: FC<DiaryOldNewValueProps> = ({
  oldValue,
  newValue
}) => {

  return (
   <TableOldNewWrapper>
    {oldValue !== null && oldValue !== undefined && (
      <>
        <span>{oldValue}</span>
        <ArrowToRightIcon fill={COLORS.FG.DISABLED} />
      </>
    )}
    <p>{newValue}</p>
  </TableOldNewWrapper>
  )
}